<template>
  <dx-button
    class="theme-button"
    styling-mode="text"
    :icon="currentTheme === 'dark' ? 'sun' : 'moon'"
    @click="toggleTheme"
    :hint="`Switch to ${currentTheme === 'dark' ? 'Light' : 'Dark'} Mode`"
  />
</template>

<script setup>
import { DxButton } from 'devextreme-vue/button';
import { themeService } from '../theme-service';

const currentTheme = themeService.currentTheme;

function toggleTheme() {
  themeService.switchAppTheme();
}
</script>
